import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionArtworkCountsVariables = Types.Exact<{
  contractSlug: Types.Scalars['citext'];
}>;


export type CollectionArtworkCounts = { artworksTotalCount: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> }, availableCount: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> }, soldCount: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> } };



export const CollectionArtworkCountsDocument = /*#__PURE__*/ `
    query CollectionArtworkCounts($contractSlug: citext!) {
  artworksTotalCount: artwork_aggregate(
    where: {isIndexed: {_eq: true}, status: {_eq: "MINTED"}, collection: {slug: {_eq: $contractSlug}}}
  ) {
    aggregate {
      count
    }
  }
  availableCount: artwork_aggregate(
    where: {isIndexed: {_eq: true}, status: {_eq: "MINTED"}, collection: {slug: {_eq: $contractSlug}}, activeSalePriceInETH: {_is_null: false}}
  ) {
    aggregate {
      count
    }
  }
  soldCount: artwork_aggregate(
    where: {isIndexed: {_eq: true}, status: {_eq: "MINTED"}, collection: {slug: {_eq: $contractSlug}}, activeSalePriceInETH: {_is_null: true}, lastSalePriceInETH: {_is_null: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

export const useCollectionArtworkCounts = <
      TData = CollectionArtworkCounts,
      TError = ClientError
    >(
      variables: CollectionArtworkCountsVariables,
      options?: Omit<UseQueryOptions<CollectionArtworkCounts, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionArtworkCounts, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionArtworkCounts, TError, TData>(
      {
    queryKey: ['CollectionArtworkCounts', variables],
    queryFn: hasuraFetcher<CollectionArtworkCounts, CollectionArtworkCountsVariables>(CollectionArtworkCountsDocument, variables),
    ...options
  }
    )};

useCollectionArtworkCounts.getKey = (variables: CollectionArtworkCountsVariables) => ['CollectionArtworkCounts', variables];

export const useInfiniteCollectionArtworkCounts = <
      TData = InfiniteData<CollectionArtworkCounts>,
      TError = ClientError
    >(
      variables: CollectionArtworkCountsVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionArtworkCounts, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionArtworkCounts, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionArtworkCounts, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionArtworkCounts.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionArtworkCounts, CollectionArtworkCountsVariables>(CollectionArtworkCountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionArtworkCounts.getKey = (variables: CollectionArtworkCountsVariables) => ['CollectionArtworkCounts.infinite', variables];


useCollectionArtworkCounts.fetcher = (variables: CollectionArtworkCountsVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionArtworkCounts, CollectionArtworkCountsVariables>(CollectionArtworkCountsDocument, variables, options);
